function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "notification",
  transform: "translate(-318.984 -420.3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "notification-2",
  "data-name": "notification",
  d: "M319.521,470.922v3.465h1.427l.727.723.727-.723h1.457v-3.465h-4.545",
  transform: "translate(-0.331 -50.422)",
  fill: "#1f1f1f",
  stroke: "#1f1f1f",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_4",
  "data-name": "Group 4",
  transform: "translate(0.05 -0.23)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_9",
  "data-name": "Line 9",
  x2: 3,
  transform: "translate(319.8 421.63)",
  fill: "none",
  stroke: "#848484",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  x2: 3,
  transform: "translate(319.8 422.432)",
  fill: "none",
  stroke: "#848484",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  x2: 3,
  transform: "translate(319.8 423.234)",
  fill: "none",
  stroke: "#848484",
  strokeWidth: 0.4
})));

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.745,
    height: 4.67,
    viewBox: "0 0 4.745 4.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5080c018.svg";
export { ForwardRef as ReactComponent };